<cw-navigation-drawer *transloco="let t">
  <div class="navigation-header">
    <div class="customer-name-container">
      @if (userConfigsFacade.canSwitchCustomerSignal()) {
        <app-navigation-country-switch/>
      }
      <div class="customer-name">
        {{ userConfigsFacade.currentCustomerName$ | async }}
      </div>
    </div>
    <cw-button
      buttonColor="accent"
      data-cy="nav-create-process-button"
      [routerLink]="createProcessRoute"
      [queryParams]="{ tableName: processTablesNames.ORDER_LIST_EXTERNAL }">
      <cw-icon icon="create" font="cortex"/>
      {{ t('Create process') }}
    </cw-button>
  </div>

  <cw-navigation-drawer-section>
    <a [routerLink]="overviewRoute" routerLinkActive #overviewLink="routerLinkActive"
      data-cy="overview-link-link">
      <cw-navigation-drawer-item
        icon="home"
        [label]="t('Overview')"
        font="material"
        [class.active]="overviewLink.isActive">
      </cw-navigation-drawer-item>
    </a>

    <a [routerLink]="processesRoute"
       [queryParams]="{ tableName: processTablesNames.ALL_EXTERNAL }"
       [routerLinkActiveOptions]="{ exact: false }"
       routerLinkActive
       #allProcessesLink="routerLinkActive"
       data-cy="all-processes-link-link">
      <cw-navigation-drawer-item
        icon="all_inbox"
        [label]="t('All processes')"
        font="material"
        [class.active]="allProcessesLink.isActive">
      </cw-navigation-drawer-item>
    </a>

    <a [routerLink]="processesRoute"
       [queryParams]="{ status: processStatuses.NEW, tableName: processTablesNames.NEW_EXTERNAL }"
       routerLinkActive
       #newlyCreatedLink="routerLinkActive"
       data-cy="newly-created-link-link">
      <cw-navigation-drawer-item
        icon="ballot"
        [label]="t('Newly created')"
        font="material"
        [class.active]="newlyCreatedLink.isActive">
      </cw-navigation-drawer-item>
    </a>

    <a [routerLink]="processesRoute"
       [queryParams]="{ status: processStatuses.READY_FOR_SHIPMENT, tableName: processTablesNames.READY_FOR_SHIPMENT_EXTERNAL }"
       routerLinkActive
       #readyForShipmentLink="routerLinkActive"
       data-cy="ready-for-shipment-link-link">
      <cw-navigation-drawer-item
        icon="inventory_2"
        [label]="t('Ready for shipment')"
        font="material"
        [class.active]="readyForShipmentLink.isActive">
      </cw-navigation-drawer-item>
    </a>

    <a [routerLink]="processesRoute"
       [queryParams]="{ status: processStatuses.PICKUP_SCHEDULED, tableName: processTablesNames.PICKUP_SCHEDULED_EXTERNAL }"
       routerLinkActive
       #pickupScheduledLink="routerLinkActive"
       data-cy="pickup-scheduled-link-link">
      <cw-navigation-drawer-item
        icon="schedule_send"
        [label]="t('Pickup scheduled')"
        font="material"
        [class.active]="pickupScheduledLink.isActive">
      </cw-navigation-drawer-item>
    </a>

    <a [routerLink]="processesRoute"
       [queryParams]="{ status: processStatuses.SENT, tableName: processTablesNames.SENT_EXTERNAL }"
       routerLinkActive
       #sentToServiceLink="routerLinkActive"
       data-cy="sent-to-service-link-link">
      <cw-navigation-drawer-item
        icon="send"
        [label]="t('Sent to service')"
        font="material"
        [class.active]="sentToServiceLink.isActive">
      </cw-navigation-drawer-item>
    </a>

    <a [routerLink]="processesRoute"
       [queryParams]="{ status: processStatuses.IN_PROGRESS, tableName: processTablesNames.IN_PROGRESS_EXTERNAL }"
       routerLinkActive
       #inProgressLink="routerLinkActive"
       data-cy="in-progress-link-link">
      <cw-navigation-drawer-item
        icon="pending"
        [label]="t('In progress')"
        font="material"
        [class.active]="inProgressLink.isActive">
      </cw-navigation-drawer-item>
    </a>

    <a [routerLink]="processesRoute"
       [queryParams]="{ status: processStatuses.INTERNAL_SENT, tableName: processTablesNames.INTERNAL_SENT_EXTERNAL }"
       routerLinkActive
       #sentToUsLink="routerLinkActive"
       data-cy="sent-to-us-link-link">
      <cw-navigation-drawer-item
        icon="undo"
        [label]="t('Sent to us')"
        font="material"
        [class.active]="sentToUsLink.isActive">
      </cw-navigation-drawer-item>
    </a>

    <a [routerLink]="processesRoute"
       [queryParams]="{ status: processStatuses.RECEIVED, tableName: processTablesNames.RECEIVED_EXTERNAL }"
       routerLinkActive
       #receivedLink="routerLinkActive"
       data-cy="received-link-link">
      <cw-navigation-drawer-item
        icon="multiple_stop"
        [label]="t('Received')"
        font="material"
        [class.active]="receivedLink.isActive">
      </cw-navigation-drawer-item>
    </a>

    <a [routerLink]="processesRoute"
       [queryParams]="{ status: processStatuses.BACKORDER, tableName: processTablesNames.BACKORDER_EXTERNAL }"
       routerLinkActive
       #backordersLink="routerLinkActive"
       data-cy="backorders-link-link">
      <cw-navigation-drawer-item
        icon="production_quantity_limits"
        [label]="t('Backorders')"
        font="material"
        [class.active]="backordersLink.isActive">
      </cw-navigation-drawer-item>
    </a>

    <a [routerLink]="processesRoute"
       [queryParams]="{ status: processStatuses.CANT_BE_SERVICED, tableName: processTablesNames.CANT_BE_SERVICED_EXTERNAL }"
       routerLinkActive
       #cantBeServicedLink="routerLinkActive"
       data-cy="cant-be-serviced-link-link">
      <cw-navigation-drawer-item
        icon="report_gmailerrorred"
        [label]="t('Can\'t be serviced')"
        font="material"
        [class.active]="cantBeServicedLink.isActive">
      </cw-navigation-drawer-item>
    </a>
  </cw-navigation-drawer-section>

  <cw-navigation-drawer-section>
    <cw-navigation-drawer-group
      [expanded]="true"
      [heading]="t('Approvals')"
      icon="task"
      font="material" >
      <a [routerLink]="processesRoute"
         [queryParams]="{ status: processStatuses.APPROVAL_REQUIRED, tableName: processTablesNames.APPROVAL_REQUIRED_EXTERNAL }"
         [routerLinkActiveOptions]="{ exact: false }"
         routerLinkActive
         #approvalRequiredLink="routerLinkActive"
         data-cy="approval-required-link-link">
        <cw-navigation-drawer-item
          [label]="t('Approval required')"
          [badgeValue]="layoutFacade.approvalsRequiredCountSignal()"
          font="material"
          [class.active]="approvalRequiredLink.isActive">
        </cw-navigation-drawer-item>
      </a>

      <a [routerLink]="processesRoute"
         [queryParams]="{ status: processStatuses.APPROVED, tableName: processTablesNames.APPROVED_EXTERNAL }"
         routerLinkActive
         #approvedLink="routerLinkActive"
         data-cy="approved-link-link">
        <cw-navigation-drawer-item
          [label]="t('Approved')"
          font="material"
          [class.active]="approvedLink.isActive">
        </cw-navigation-drawer-item>
      </a>

      <a [routerLink]="processesRoute"
         [queryParams]="{ status: processStatuses.REJECTED, tableName: processTablesNames.REJECTED_EXTERNAL }"
         routerLinkActive
         #rejectedLink="routerLinkActive"
         data-cy="rejected-link-link">
        <cw-navigation-drawer-item
          [label]="t('Rejected')"
          font="material"
          [class.active]="rejectedLink.isActive">
        </cw-navigation-drawer-item>
      </a>
    </cw-navigation-drawer-group>

    <cw-navigation-drawer-group [heading]="t('Processes by type')" icon="label" font="material">
      <a [routerLink]="processesRoute"
         [queryParams]="{ type: ProcessType.REPAIR, tableName: processTablesNames.REPAIR_EXTERNAL }"
         routerLinkActive
         #repairsLink="routerLinkActive"
         data-cy="repairs-link-link">
        <cw-navigation-drawer-item
          [label]="t('Repairs')"
          font="material"
          [class.active]="repairsLink.isActive">
        </cw-navigation-drawer-item>
      </a>

      @if (userConfigsFacade.swapEnabledSignal()) {
        <a [routerLink]="processesRoute"
           [queryParams]="{ type: ProcessType.SWAP, tableName: processTablesNames.SWAP_EXTERNAL }"
           routerLinkActive
           #swapLink="routerLinkActive"
           data-cy="swap-link-link">
          <cw-navigation-drawer-item
            [label]="t('Swap')"
            font="material"
            [class.active]="swapLink.isActive">
          </cw-navigation-drawer-item>
        </a>
      }

      <a [routerLink]="processesRoute"
         [queryParams]="{ type: ProcessType.PURCHASE, tableName: processTablesNames.PURCHASE_EXTERNAL }"
         routerLinkActive
         #purchasesLink="routerLinkActive"
         data-cy="purchases-link-link">
        <cw-navigation-drawer-item
          [label]="t('Purchases')"
          font="material"
          [class.active]="purchasesLink.isActive">
        </cw-navigation-drawer-item>
      </a>

      <a [routerLink]="processesRoute"
         [queryParams]="{ type: ProcessType.REPAIR_REQUEST, tableName: processTablesNames.REPAIR_REQUEST_EXTERNAL }"
         routerLinkActive
         #repairRequestLink="routerLinkActive"
         data-cy="repair-request-link-link">
        <cw-navigation-drawer-item
          [label]="t('Repair request')"
          font="material"
          [class.active]="repairRequestLink.isActive">
        </cw-navigation-drawer-item>
      </a>

      <a [routerLink]="processesRoute"
         [queryParams]="{ type: ProcessType.REPAIR_REPLACEMENT, tableName: processTablesNames.REPAIR_REPLACEMENT_EXTERNAL }"
         routerLinkActive
         #repairReplacementsLink="routerLinkActive"
         data-cy="repair-replacements-link-link">
        <cw-navigation-drawer-item
          [label]="t('Repair replacements')"
          font="material"
          [class.active]="repairReplacementsLink.isActive">
        </cw-navigation-drawer-item>
      </a>

      <a [routerLink]="processesRoute"
         [queryParams]="{ type: ProcessType.SERVICE_NOT_POSSIBLE, tableName: processTablesNames.SERVICE_NOT_POSSIBLE_EXTERNAL }"
         routerLinkActive
         #serviceNotPossibleLink="routerLinkActive"
         data-cy="service-not-possible-link-link">
        <cw-navigation-drawer-item
          [label]="t('Service not possible')"
          font="material"
          [class.active]="serviceNotPossibleLink.isActive">
        </cw-navigation-drawer-item>
      </a>
    </cw-navigation-drawer-group>
  </cw-navigation-drawer-section>

  <cw-navigation-drawer-section>
    <a [routerLink]="notificationsRoute"
      routerLinkActive
      #notificationsLink="routerLinkActive"
      data-cy="notifications-link-link">
      <cw-navigation-drawer-item
        icon="notifications"
        [label]="t('Notifications')"
        [badgeValue]="layoutFacade.unreadNotificationsCountSignal()"
        font="material"
        [class.active]="notificationsLink.isActive">
      </cw-navigation-drawer-item>
    </a>

    <a [routerLink]="historyRoute"
       [queryParams]="{ tableName: processTablesNames.HISTORY_EXTERNAL }"
       routerLinkActive
       #historyLink="routerLinkActive"
       data-cy="history-link-link">
      <cw-navigation-drawer-item
        icon="summarize"
        [label]="t('History')"
        font="material"
        [class.active]="historyLink.isActive">
      </cw-navigation-drawer-item>
    </a>

    <a [routerLink]="analyticsRoute"
      routerLinkActive
      #analyticsLink="routerLinkActive"
      data-cy="analytics-link-link">
      <cw-navigation-drawer-item
        icon="analytics"
        [label]="t('Analytics')"
        font="material"
        [class.active]="analyticsLink.isActive">
      </cw-navigation-drawer-item>
    </a>

    <a [routerLink]="helpRoute"
      [routerLinkActiveOptions]="{ exact: false }"
      routerLinkActive
      #helpLink="routerLinkActive"
      data-cy="help-link-link">
      <cw-navigation-drawer-item
        icon="help"
        [label]="t('Help')"
        font="material"
        [class.active]="helpLink.isActive">
      </cw-navigation-drawer-item>
    </a>
  </cw-navigation-drawer-section>
</cw-navigation-drawer>
